import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaMountain, FaLightbulb, FaAtom } from "react-icons/fa";
import { motion } from "framer-motion";
import "./VisionMissionSection.css";

const MissionVisionValues = () => {
  const items = [
    {
      icon: <FaMountain className="icon mission" />,
      title: "OUR MISSION",
      text: "To deliver strategic, technology-driven project management solutions that empower businesses to execute with precision, innovate with confidence, and scale with purpose — from the UAE to the world.",
      animation: { x: -80, y: 0 }, // Slide from left
    },
    {
      icon: <FaLightbulb className="icon vision" />,
      title: "OUR VISION",
      text: "To become a globally recognized leader in project management and intelligent automation, trusted by organizations across industries for bridging strategy and execution through innovation, integrity, and impact.*",
      animation: { x: 0, y: 80 }, // Slide from bottom
    },
    {
      icon: <FaAtom className="icon values" />,
      title: "OUR VALUES",
      text: "Execution Excellence We turn strategy into results with precision, discipline, and accountability.Innovation First We embrace emerging technologies like AI to build smarter, faster, and scalable solutions..",
      animation: { x: 80, y: 0 }, // Slide from right
    },
  ];

  return (
    <section className="mission-vision-values py-5">
      <Container>
        <Row className="text-center">
          {items.map((item, index) => (
            <Col md={4} key={index} className="mb-4">
              <motion.div
                className="item"
                initial={{ opacity: 0, x: item.animation.x, y: item.animation.y }}
                whileInView={{ opacity: 1, x: 0, y: 0 }}
                viewport={{ once: false, amount: 0.2 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                {item.icon}
                <h5 className="title">{item.title}</h5>
                <div className="divider"></div>
                <p className="description">{item.text}</p>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MissionVisionValues;
